import React, { useState, useEffect } from 'react';
import { History, AlertCircle } from 'lucide-react';
import { supabase } from '../lib/supabase';

interface HistoricalEvent {
  year: number;
  description: string;
}

export const HistoricalEvent: React.FC = () => {
  const [event, setEvent] = useState<HistoricalEvent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHistoricalEvent = async () => {
      try {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;

        const { data, error } = await supabase
          .from('historical_events')
          .select('*')
          .eq('day', day)
          .eq('month', month)
          .order('year', { ascending: false })
          .limit(1);

        if (error) {
          console.error('Error fetching historical event:', error);
          setError('לא ניתן לטעון את האירוע ההיסטורי כרגע');
          return;
        }

        if (data && data.length > 0) {
          setEvent({
            year: data[0].year,
            description: data[0].description
          });
        }
      } catch (error) {
        console.error('Error in fetchHistoricalEvent:', error);
        setError('אירעה שגיאה בטעינת האירוע ההיסטורי');
      } finally {
        setLoading(false);
      }
    };

    fetchHistoricalEvent();
  }, []);

  if (loading) return null;

  if (error) {
    return (
      <div className="w-full max-w-2xl mx-auto mb-8 bg-red-50 rounded-lg p-4 shadow-sm">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
          <div className="flex-1">
            <p className="text-red-700">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!event) return null;

  return (
    <div className="w-full max-w-2xl mx-auto mb-8 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start gap-3">
        <History className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
        <div className="flex-1">
          <h3 className="font-semibold text-gray-800 mb-1">הידעת?</h3>
          <p className="text-gray-600">{event.description}</p>
        </div>
      </div>
    </div>
  );
};